import { getOptionFunc } from '../state';
import { APP_SWITCHER_TARGET_ID, MENU_DOM_ID, NAV_MENU_DOM_TARGET_ID } from '../constants';
export const getGlobalStyle = (options) => {
    const getOption = getOptionFunc(options);
    const theme = getOption('themeOption');
    const isLightTheme = theme === 'light';
    const targetId = getOption('targetId') || APP_SWITCHER_TARGET_ID;
    // const backgroundColor = isLightTheme ? '#ffffff' : '#ffffff';
    const borderColor = isLightTheme ? '#ababab' : '#333333';
    return `
    #${targetId} {
        position: relative;
    }

    #${NAV_MENU_DOM_TARGET_ID}_${targetId} {
        position: absolute;
    }

    /* Navigation drop menu */
    .app-switcher-nav-wrap {
        width: 300px;
        padding: .5em 0;
        z-index: 1;
        background-color: rgb(255, 255, 255);
        border: 1px solid ${borderColor};
    }

    /* menu content */
    #${MENU_DOM_ID}_${targetId} {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }

    #${MENU_DOM_ID}_${targetId}::-webkit-scrollbar {
        display: none;
    }

    #${MENU_DOM_ID}_${targetId} pre {
        font-size: 12px;
        color: 'gray';
        font-family; 'monospace';
    }

    .mas-hidden {
        display: none;
    }
`;
};
